//州情報一覧
export const FETCH_CITIES_REQUEST = 'FETCH_CITIES_REQUEST'
export const SET_CITIES_DATA = 'SET_CITIES_DATA'
